import styled from 'styled-components'

export const StyledImg = styled.img`
  display: block;
  width: 100%;
  height: auto;
`

export const ExampleImageContainer = styled.div`
  min-height: 280px;
  display: flex;
  align-items: center;
  max-width: 700px;
`
